import React, { InputHTMLAttributes, useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import logo from "../../assets/images/dofy-logo-blue.png"
import { aes_encryption, countrycodenumber, isIn } from '../../helpers/Helper'
import { HelperConstant } from '../../helpers/HelperConstant'
import { CustomButton } from 'components/shared/CustomButton'
import { IPersonModel } from 'models/Person.Model'
import CommonService from 'services/CommonService'
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model'
import AssigneeModal from 'components/assignemodal/AssigneeModal'
import { getPersonId, isRider } from '../../helpers/TokenHelper'

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    orderSummaryInfo: any,
    orderId: any,
    reRender: any,
    showEdit: any
}

const AssigneInfo = ({ orderSummaryInfo, orderId, reRender, showEdit }: inputProps) => {
    const [showModal, setShowModal] = useState(false);
    const [AssigneeList, setAssigneeList] = useState<Array<IPersonModel>>([]);
    const [TechnicianAssignId, setTechnicianAssignId] = useState();
    const [modal_center, setmodal_center] = useState(false);
    const [load, setLoad] = useState<boolean>(false);
    const riderlogin: boolean = isRider() ?? false;
    const [isAssignClicked, setIsAssignClicked] = useState<boolean>(false);

    const TechnicianAssigneeData = (id) => {
        setIsAssignClicked(true);
        var personId = getPersonId() as any;
        // var personId = parseInt(person);
        if (id != undefined || id != null) {
            CommonService.postWithQuadrupleEntity("sell", "AssignProcess", orderId, id, personId, new Date()).then(res => {
                if (res.status === 200) {
                    setmodal_center(false);
                    setLoad(!load)
                    setIsAssignClicked(false);
                    // setSuccessToast(true);
                    reRender(!load)
                }
            }).catch(e => console.log(e))
        }
    }

    // const eOrderId = aes_encryption(orderId);

    const AssigneeListData = () => {
        CommonService.postWithSingleParam('personModel', 'GetAssigneeList', orderId ? orderId : "0").then(res => {
            if (res.status === 200) {
                setAssigneeList(res.data)

            }
        }).catch(e => console.log(e))
    }

    useEffect(() => {
        AssigneeListData();
    }, [load, setShowModal])

    useEffect(() => {
        setLoad(load)
    }, [load])

    return (
        <React.Fragment>
            <Row>
                <Col xl={12} className="mt-3">
                    {orderSummaryInfo?.AssigneeDetails === null ?
                        <Row>
                            <Col xl={12} className='text-center'>
                                <p className='font-size-18 fw-semibold text-dofy m-0 mb-2'>Yet to assign Assignee. Kindly assign it</p>
                                {riderlogin ? null :
                                    <>
                                        {showEdit ?
                                            <div>
                                                {orderSummaryInfo?.AssigneeDetails === null ?
                                                    <CustomButton type={'button'} btnClassName={'btn-success w-md my-2'} iconClasssName={undefined} name={'Assign'} onClick={() => setmodal_center(true)} />
                                                    :
                                                    <CustomButton type={'button'} btnClassName={'btn-success w-md my-2'} iconClasssName={undefined} name={'Re-assign'} onClick={() => setmodal_center(true)} />
                                                }
                                            </div> : null}
                                    </>}
                            </Col>
                        </Row> :
                        <Row>
                            <Col xl={12} className='text-center'>
                                <Row className='justify-content-center'>
                                    <Col className='text-start' xl={12} lg={4} md={4} sm={12} xs={12}>
                                        <div className='order-section-personal'>
                                            <div>
                                                <i className="fas fa-motorcycle check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                                <span className='font-size-14 text-dofy fw-semibold'>{orderSummaryInfo?.AssigneeDetails?.AssigneeName} {
                                                    orderSummaryInfo?.AssigneeDetails?.AliasName ? `- ${orderSummaryInfo?.AssigneeDetails?.AliasName}` : ''
                                                }</span>
                                            </div>
                                            <div>
                                                <i className="bx bxs-phone-call check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                                <span className='font-size-14 text-dofy fw-semibold'>{countrycodenumber(orderSummaryInfo?.AssigneeDetails?.Mobile)}{orderSummaryInfo?.AssigneeDetails?.Mobile}</span>
                                            </div>
                                            {orderSummaryInfo?.AssigneeDetails?.SecondaryMobile && orderSummaryInfo?.AssigneeDetails?.Mobile !== orderSummaryInfo?.AssigneeDetails?.SecondaryMobile ?
                                                <div>
                                                    <i className="bx bxs-phone-call check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                                    <span className='font-size-14 text-dofy fw-semibold'>{countrycodenumber(orderSummaryInfo?.AssigneeDetails?.SecondaryMobile)}{orderSummaryInfo?.AssigneeDetails?.SecondaryMobile}</span>
                                                </div> : null}
                                            <div>
                                                <i className="mdi mdi-email-check check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                                <span className='font-size-14 text-dofy fw-semibold'>{orderSummaryInfo?.AssigneeDetails?.Email}</span>
                                            </div>
                                            {orderSummaryInfo?.StatusName === HelperConstant.orderStatus.PendingOrders ? null :
                                                <div>
                                                    <i className="fas fa-map-marked-alt check-nav-icon mt-2 mb-2 font-size-14 me-2 text-dofy"></i>
                                                    {isIn() ?
                                                        <span className='font-size-14 text-dofy fw-normal'> {orderSummaryInfo?.AssigneeDetails?.Address + ',' + " "}<br />
                                                            {orderSummaryInfo?.AssigneeDetails?.City} {orderSummaryInfo?.AssigneeDetails?.Pincode !== "null" ? `- ${orderSummaryInfo?.AssigneeDetails?.Pincode}` : ''}
                                                        </span> : <span className='font-size-14 text-dofy fw-normal'>  {orderSummaryInfo?.AssigneeDetails?.Address + ',' + " "} <br />
                                                            {orderSummaryInfo?.AssigneeDetails?.City}.
                                                        </span>}
                                                </div>}
                                            <div >
                                                {riderlogin ? null :
                                                    <>
                                                        {showEdit ?
                                                            <div>
                                                                {orderSummaryInfo?.AssigneeDetails === null ?
                                                                    <CustomButton type={'button'} btnClassName={'btn-success w-md my-2'} iconClasssName={undefined} name={'Assign'} onClick={() => setmodal_center(true)} />
                                                                    :
                                                                    <CustomButton type={'button'} btnClassName={'btn-success w-md my-2'} iconClasssName={undefined} name={'Re-assign'} onClick={() => setmodal_center(true)} />
                                                                }
                                                            </div> : null}
                                                    </>}
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>}
                </Col>
            </Row>
            <AssigneeModal aliasname={AssigneeList} setModelOpen={setmodal_center} modalOpen={modal_center} getTechnicianAssigneeId={TechnicianAssigneeData} assigneeList={AssigneeList} isAssigned={isAssignClicked} />
        </React.Fragment>
    )
}

export default AssigneInfo
